import { useDropzone } from "react-dropzone";
import { twMerge } from "tailwind-merge";
import { v4 as uuidv4 } from "uuid";

import icCloseBlack from "@/assets/images/console/icCloseBlack.svg";
import icFileUpload from "@/assets/images/user/icFileUpload.svg";
import { usePopupStore } from "@/store/common/usePopupStore";

export type FileData = { idx: string | number; original_name: string; url: string };

interface FileUploadProps {
    uploadFiles: FileData[];
    setFiles: (file: FileData[]) => void;
    setFilesData: (fileData: File[]) => void;
    boxClassName?: string;
    className?: string;
    accept?: string;
    handleDelt?: (idx: number, file_idx: number | string) => void;
    maxLength?: number;
}

const FileUpload: React.FC<FileUploadProps> = ({
    uploadFiles = [],
    setFiles,
    setFilesData,
    boxClassName,
    className,
    accept,
    handleDelt,
    maxLength = 1,
}) => {
    const { setConfirmPop } = usePopupStore();
    const { getRootProps, getInputProps } = useDropzone({
        accept: accept ? { [accept]: [] } : undefined,
        multiple: true,
        onDrop: acceptedFiles => {
            const files = acceptedFiles.length + uploadFiles.length;

            if (acceptedFiles.length === 0) {
                return;
            } else if (files > maxLength) {
                setConfirmPop(true, `최대 ${maxLength}개까지 첨부 가능합니다.`, 1);
            } else {
                const newFiles = acceptedFiles.map(file => ({
                    idx: uuidv4(), // 고유한 ID
                    original_name: file.name,
                    url: URL.createObjectURL(file),
                }));

                // 파일 리스트를 업데이트
                setFiles([...uploadFiles, ...newFiles]);

                // 실제 파일 데이터도 업데이트
                setFilesData([...acceptedFiles]);
            }
        },
    });

    // 파일 삭제
    const handleDeltFile = (idx: number, file_idx: number | string) => {
        if (maxLength > 1 && handleDelt) {
            handleDelt(idx, file_idx);
        } else if (maxLength === 1) {
            setFiles([]);
            setFilesData([]);
        }
    };

    return (
        <div className={boxClassName}>
            {uploadFiles.length < maxLength && (
                <div {...getRootProps({ className: "dropzone" })}>
                    <div className={twMerge("bg-white border-2 border-dashed border-[#ddd] rounded-[12px]", className)}>
                        <input {...getInputProps({ className: "hidden" })} />
                        <label className="flex h-full cursor-pointer flex-col items-center justify-center gap-[4px] gap-[8px] p-[16px_24px] text-center text-[14px] text-[#666] md:p-[20px_24px] md:text-[16px]">
                            <img src={icFileUpload} alt="파일첨부" />
                            <span>
                                파일 첨부는 1개만 등록 가능합니다. <br />
                                10mb 이상의 대용량 파일 첨부 시 운영사무국 메일로 별도 접수 바랍니다!
                            </span>
                        </label>
                    </div>
                </div>
            )}
            {uploadFiles.length > 0 && (
                <ul className="mt-[8px] flex flex-col gap-[4px] rounded-[8px] bg-[#F1F4F9] py-[8px]">
                    {uploadFiles.map((file, i) => (
                        <li key={`file_${i}`}>
                            <div className="flex items-center justify-between px-[20px]">
                                <p className="w-[calc(100%-30px)] truncate text-[14px] text-[#1A2448]">
                                    {file.original_name}
                                </p>
                                <button
                                    type="button"
                                    className="size-[20px] p-[4px]"
                                    onClick={() => {
                                        handleDeltFile(i, file.idx);
                                    }}
                                >
                                    <img src={icCloseBlack} alt="삭제" />
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default FileUpload;
